<template>
	<div>
		<el-row style="margin: 15px 0;">
			<el-button type="text" size="small" @click='$router.back(-1)'>返回上一级</el-button>
		</el-row>
		
		<el-table border stripe row-key="id" :data="repliesList" style="width: 100%" :tree-props="{children: 'children'}">
			<!-- <el-table-column type="index" width="50"></el-table-column> -->
			<el-table-column prop="nickname" label="昵称" width="180"></el-table-column>
			<el-table-column prop="phone" label="手机号" width="180"></el-table-column>
			<el-table-column prop="content" label="内容" width="180"></el-table-column>
			<el-table-column prop="good_times" label="点赞数" width="180"></el-table-column>
			<el-table-column prop="created_at" label="创建时间" width="200"></el-table-column>
			<el-table-column  label="操作">
				<template slot-scope="scope">
					<el-button type="text" size="small" @click="deleteComments(scope.row)">删除</el-button>
				</template>
			</el-table-column>
		</el-table>
		<!-- 分页 -->
		<!-- <div style="padding: 15px 0; text-align: right;">
			<el-pagination :hide-on-single-page="true" background @current-change="handleCurrentChange"
				:current-page="pagination.page" :page-size="pagination.page_size"
				layout="total, prev, pager, next, jumper" :total="total">
			</el-pagination>
		</div> -->
	</div>
</template>

<script>
	export default {
		data() {
			return {
				pagination: {
					page: 1,
					per_page: 15
				},
				total: 0,
				list: [],
				repliesList: []
			}
		},
		methods: {
			getArticleDetail(id) {
				this.$axios.get('announcement/'+id).then(res => {
					if(!res.code){
						this.$message.error('获取详情失败')
						return 
					}
					this.repliesList = res.data.announcement_liuyans.map((item) =>{
					    item.children = []
					    let replys = res.data.announcement_feedBacks.filter((reply) =>{ return reply.fid == item.id })
					    if(replys.length) {
					        item.children = replys
					    }
						return item
					})
				});
			},
			deleteComments(row) {
				this.$confirm("确定删除该评论及子评论?", "提示", {
				  confirmButtonText: "确定",
				  cancelButtonText: "取消",
				  type: "warning"
				}).then(() => {
					let ids = [row.id]
					if(row.children) {
						for(let i = 0,l = row.children.length;i < l;i++) {
							ids.push(row.children[i].id)
						}
					}
				    this.$axios.delete("del_announcement_feedbacks",{ids}).then(res => {
				      this.$message({
				        message: res.message,
				        type: "success"
				      });
				      if (res.code == 1) {
				        this.getArticleDetail(this.$route.params.id);
				      }
				    });
				  })
			}
		},
		mounted() {
			this.getArticleDetail(this.$route.params.id)
		}
	}
</script>

<style scoped lang="scss">
	.pic-preview{
		width: 240px;
		max-height: 240px;
	}
</style>